import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-column",
  "use": "icon-column-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-column\">\n<rect x=\"22.474\" y=\"22.475\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFFCDB\" stroke=\"#DAB866\" stroke-width=\"2.8953\" stroke-miterlimit=\"22.9256\" width=\"155.051\" height=\"155.051\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol